// extracted by mini-css-extract-plugin
export var brand = "_9t-9";
export var compact = "_9t-6";
export var extraSmall = "_9t-7";
export var icon = "_9t-0";
export var large = "_9t-4";
export var light = "_9t-1";
export var medium = "_9t-5";
export var outline = "_9t-b";
export var primaryDark = "_9t-a";
export var primaryLight = "_9t-8";
export var primaryModern = "_9t-c";
export var success = "_9t-2";
export var successSolid = "_9t-3";